/**
 * FIRMA DE TANDA EN EL WORKFLOW DE JUAN (Mario, 25/26-oct R29; WFT-10): lo que la ficha dice en palabras.
 * Quién puede firmar lo decide el núcleo (`toca_firmar`, la regla de «Por aprobar»); aquí solo se suma el permiso.
 */

export function puedeFirmar(f: any, tienePermisoAprobar: boolean): boolean {
  return !!f && tienePermisoAprobar && !!f.toca_firmar && f.solicitud?.estado === 'EN_CURSO';
}

export function estado(s: any, total: number): { texto: string; clase: string } {
  if (s?.estado === 'APROBADA') return { texto: 'Aprobada', clase: 'kb-badge-exito' };
  if (s?.estado === 'DEVUELTA') return { texto: 'Devuelta', clase: 'kb-badge-neutro' };
  const e = s?.etapa;
  return { texto: `Espera firma${e ? ` · ${e.orden} de ${total} · ${e.rol_nombre}` : ''}`, clase: 'kb-badge-alerta' };
}

export function textoEvento(e: any): string {
  const quien = e?.username || 'El sistema';
  switch (e?.tipo) {
    case 'CREADA': return `${quien} envió la tanda`;
    case 'APROBADA': return `${quien} firmó${e.etapa?.rol_nombre ? ` como ${e.etapa.rol_nombre}` : ''}`;
    case 'DEVUELTA': return `${quien} la devolvió${e.motivo ? `: ${e.motivo}` : ''}`;
    case 'FINALIZADA': return 'Tanda aprobada: lista para su lote';
    default: return `${quien} · ${String(e?.tipo || '').toLowerCase()}`;
  }
}
